import { Component } from '@angular/core';
@Component({
  selector: 'ba-server-unavailable',
  templateUrl: './server-unavailable.component.html'
})
export class ServerUnavailableComponent {

  constructor() { }

}
